import {configureStore} from '@reduxjs/toolkit'
import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux'
import {combineReducers} from 'redux'
import {
  apSearchValueReducer,
  updateAerialPhotographyReducer,
  updateAPFrameDataReducer,
  updateAPProjectDetailsReducer,
} from '../components/aerialphotography-components/ap.slice'
import {AP_CART, apCartSlice} from '../components/aerialphotography-components/apCart.slice'
import {AP_FRAMES, apFramesSlice} from '../components/aerialphotography-components/apFrames.slice'
import {floodLayerReducer, floodTabReducer, updateFloodDataReducer} from '../components/flood-components/slice'
import {
  candidatePlacesReducer,
  resetPlaceViewReducer,
  searchFiltersReducer,
  searchValueReducer,
  updatePlacenameDataReducer,
} from '../components/placenames-components/slice'
import {planningSearchValueReducer, updatePlanningDataReducer} from '../components/planning-components/slice'
import {candidateAddressesReducer} from './candidateAddresses.slice'
import {disclaimerReducer, recaptchaReducer, selectedParcelReducer} from './slice'
import {AP_DRAW_MODE, apDrawModeSlice} from "../components/aerialphotography-components/apDrawPoygonSlice";

const rootReducer = combineReducers({
  planningData: updatePlanningDataReducer,
  placenameData: updatePlacenameDataReducer,
  recaptcha: recaptchaReducer,
  candidateAddresses: candidateAddressesReducer,
  candidateAddressesReverse: candidateAddressesReducer,
  candidatePlaces: candidatePlacesReducer,
  searchValue: searchValueReducer,
  planningSearchValue: planningSearchValueReducer,
  searchFilters: searchFiltersReducer,
  floodData: updateFloodDataReducer,
  disclaimer: disclaimerReducer,
  floodTab: floodTabReducer,
  selectedParcel: selectedParcelReducer,
  floodActiveLayer: floodLayerReducer,
  resetPlaceMapView: resetPlaceViewReducer,
  apData: updateAerialPhotographyReducer,
  apSearchValue: apSearchValueReducer,
  apFrameData: updateAPFrameDataReducer,
  apProjectDetails: updateAPProjectDetailsReducer,
  [AP_DRAW_MODE]: apDrawModeSlice.reducer,
  [AP_FRAMES]: apFramesSlice.reducer,
  [AP_CART]: apCartSlice.reducer,
})

export type RootState = ReturnType<typeof rootReducer>

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware(),
})

export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch // Export a hook that can be reused to resolve types

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export default store